/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Bump_DisabledInputs */

const cs_portals_bump_disabled = /** @type {(inputs: Portals_Bump_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív zapněte export na portál, než nastavíte bump.`)
};

const en_portals_bump_disabled = /** @type {(inputs: Portals_Bump_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable the portal export before configuring bump.`)
};

/**
* | output |
* | --- |
* | "Enable the portal export before configuring bump." |
*
* @param {Portals_Bump_DisabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_disabled = /** @type {((inputs?: Portals_Bump_DisabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_DisabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_disabled(inputs)
	return cs_portals_bump_disabled(inputs)
});